
import GroupService from '../../services/groups'

export const state = {}

export const mutations = {}


export const getters = {}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  // eslint-disable-next-line no-unused-vars
  init({ state, dispatch }) {},

  // eslint-disable-next-line no-unused-vars
  createGroup ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      
      GroupService.createGroup(payload).then(response => { 
        if (response.data && response.data.data._id) { 
          resolve(response)
        }else{
          reject({message: 'Error creating group'})
        }
      })
      .catch(error => { reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  getGroups ({ commit },params) {

    return new Promise((resolve, reject) => { 
      GroupService.getGroups(params).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  getGroup ({ commit }, id) {

    return new Promise((resolve, reject) => { 
      GroupService.getGroup(id).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  deleteGroup ({ commit }, id) {

    return new Promise((resolve, reject) => { 
      GroupService.deleteGroup(id).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  updateGroup ({ commit }, group) {

    return new Promise((resolve, reject) => { 
      GroupService.updateGroup(group).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },
}